import { CookieService } from 'ngx-cookie-service';
import { CustomerAuthService } from '../public/customer-auth.service';
import { ClearCustomerInfo } from '../public/store/+state/stores.actions';
import { SelectedStoreState } from '../stores/+state/stores.reducer';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { CheckoutService } from '../public/store/store-checkout/checkout.service';

@Injectable({
  providedIn: 'root', // This makes the service available application-wide
})
export class CustomerDataService {
  constructor(
    private cookieService: CookieService,
    private customerAuthService: CustomerAuthService,
    private store: Store<SelectedStoreState>,
    private checkoutService: CheckoutService,
  ) {}

  cleanCustomerData() {
    this.checkoutService.setOrderMetaState('customerName', null);
    this.checkoutService.setOrderMetaState('customerEmail', null);
    this.checkoutService.setOrderMetaState('customerPhoneNumber', null);

    this.cookieService.delete('customerEmail', '/');
    this.cookieService.delete('customerName', '/');
    this.cookieService.delete('customerPhoneNumber', '/');
    this.cookieService.delete('deliveryCity', '/');
    this.cookieService.delete('deliveryPostCode', '/');
    this.cookieService.delete('deliveryStreetAddress', '/');
    this.cookieService.delete('floorNumber', '/');
    this.cookieService.delete('pickupCity', '/');
    this.cookieService.delete('pickupPostCode', '/');
    this.cookieService.delete('pickupStreetAddress', '/');
    this.cookieService.delete('pickupFloorNumber', '/');
    this.cookieService.delete('deliveryHouseNo', '/');
    this.store.dispatch(new ClearCustomerInfo());
    this.customerAuthService.logout();
  }
}
